import { StatusEnum } from 'models/general';
import TickIcon from 'assets/icons/tick.svg';
import WarningIcon from 'assets/icons/warning.svg';
import ProgressIcon from 'assets/icons/progress.svg';
import useModifiers from 'hooks/useModifiers';

export enum StatusIconModifier {
  OVERVIEW = 'overview',
  VALIDATION = 'validation',
}
export interface StatusIconProps {
  type: StatusEnum;
  modifiers: StatusIconModifier[];
}

function StatusIcon(props: StatusIconProps) {
  const mods = useModifiers(props.modifiers);

  return (
    <span className={`ct_statusIcon _${props.type} ${mods}`}>
      {props.type === StatusEnum.ACTIVE && <TickIcon />}
      {props.type === StatusEnum.SUCCESS && <TickIcon />}
      {props.type === StatusEnum.PROGRESS && <ProgressIcon />}
      {props.type === StatusEnum.WARNING && <WarningIcon />}
      {props.type === StatusEnum.ERROR && <WarningIcon />}
      {props.type === StatusEnum.GRAY && <WarningIcon />}
      {props.type === StatusEnum.GRAY_OUTLINE && <WarningIcon />}
      {props.type === StatusEnum.GRAY_OUTLINE_SUCCESS && <TickIcon />}
      {props.type === StatusEnum.LIGHT_GRAY && <WarningIcon />}
      {props.type === StatusEnum.LIGHT_GREEN && <TickIcon />}
    </span>
  );
}

export default StatusIcon;
